import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] border-t border-ink-600 text-zinc-300"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 pt-20 pb-8">
        <div className="grid grid-cols-12 gap-8 md:gap-10">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center gap-3 group">
              <span className="relative flex items-center justify-center w-8 h-8 border border-white/20 group-hover:border-[#00F0FF] transition-colors">
                <span className="absolute inset-1 bg-[#00F0FF] shadow-[0_0_18px_2px_rgba(0,240,255,0.55)]" />
                <span className="absolute -right-1 -bottom-1 w-2 h-2 bg-[#00F0FF] pulse-dot" />
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-display text-base font-extrabold tracking-tight text-white">
                  HUMINT<span className="text-cy">.</span>
                </span>
                <span className="font-mono text-[9px] tracking-[0.28em] text-zinc-500 mt-0.5">
                  HUMAN INTELLIGENCE
                </span>
              </div>
            </div>
            <p className="mt-6 text-sm text-zinc-400 leading-relaxed max-w-xs">
              The new HRBP playbook for Bangalore's IT, Product and AI organisations. Diagnose.
              Discover. Deliver.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="mt-8 inline-flex items-center gap-2 bg-cy text-ink px-5 py-3 text-sm font-semibold hover:bg-white transition-colors group"
            >
              Start Diagnosis
              <ArrowUpRight
                size={16}
                weight="bold"
                className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
              />
            </Link>
          </div>

          <Column
            title="Practice"
            items={[
              ["Services", "/services"],
              ["Impact", "/impact"],
              ["Insights", "/insights"],
              ["FAQs", "/#faq"],
              ["Contact", "/contact"],
            ]}
            testid="footer-col-practice"
          />

          <Column
            title="Contact"
            items={[
              ["+91 6362 073 298", "tel:+916362073298"],
              ["connect@hihumint.com", "mailto:connect@hihumint.com"],
              ["Bangalore · India", null],
              ["LinkedIn ↗", "https://www.linkedin.com/in/humint"],
            ]}
            testid="footer-col-contact"
          />
        </div>

        <div className="mt-20 md:mt-24 select-none">
          <div className="font-display font-black tracking-tighter text-white leading-[0.8] text-[24vw] md:text-[20vw]">
            HUMINT<span className="text-cy">.</span>
          </div>
        </div>

        <div className="mt-8 border-t border-ink-600 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="font-mono text-[11px] text-zinc-500">
            © {year} HumInt Advisory. All rights reserved.
          </div>
          <div className="font-mono text-[11px] text-zinc-500">
            Diagnose · Discover · Deliver
          </div>
        </div>
      </div>
    </footer>
  );
}

function Column({ title, items, testid }) {
  return (
    <div className="col-span-6 md:col-span-3" data-testid={testid}>
      <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-zinc-500 mb-4">
        {title}
      </div>
      <ul className="space-y-2 text-sm">
        {items.map(([label, href]) =>
          href ? (
            <li key={label}>
              {href.startsWith("http") ? (
                <a
                  href={href}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="text-zinc-300 hover:text-cy"
                >
                  {label}
                </a>
              ) : href.startsWith("mailto") || href.startsWith("tel") ? (
                <a href={href} className="text-zinc-300 hover:text-cy">
                  {label}
                </a>
              ) : (
                <Link to={href} className="text-zinc-300 hover:text-cy">
                  {label}
                </Link>
              )}
            </li>
          ) : (
            <li key={label} className="text-zinc-500">
              {label}
            </li>
          ),
        )}
      </ul>
    </div>
  );
}
